<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  stage: { type: Object, default: null },
  compact: { type: Boolean, default: false },
});

const { t } = useI18n();

const label = computed(
  () => props.stage?.name || t('TELETEL_LIFECYCLE.UNCLASSIFIED')
);

const toneClasses = computed(() => {
  if (!props.stage) return 'bg-n-slate-3 text-n-slate-11';
  if (props.stage.archived_at) return 'bg-n-slate-3 text-n-slate-10';
  if (props.stage.category === 'won') return 'bg-n-teal-3 text-n-teal-11';
  if (props.stage.category === 'lost') return 'bg-n-ruby-3 text-n-ruby-11';
  return 'bg-n-blue-3 text-n-blue-11';
});
</script>

<template>
  <span
    class="inline-flex min-w-0 items-center gap-1.5 rounded-full font-medium"
    :class="[
      toneClasses,
      compact ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs',
    ]"
    :title="label"
  >
    <span
      v-if="stage?.color"
      class="size-2 flex-shrink-0 rounded-full border border-n-weak"
      :style="{ backgroundColor: stage.color }"
    />
    <span v-if="stage?.emoji" aria-hidden="true">{{ stage.emoji }}</span>
    <span class="truncate">{{ label }}</span>
    <span v-if="stage?.archived_at" class="sr-only">
      {{ t('TELETEL_LIFECYCLE.STAGES.ARCHIVED') }}
    </span>
  </span>
</template>
